import { Link } from '@sravni/react-design-system/lib/Typography';
import type { DOMNode } from 'html-react-parser';
import parser, { domToReact } from 'html-react-parser';
import sanitizeHtml from 'sanitize-html';

export const SafeHtml = ({ html }: { html: string }) =>
  parser(
    sanitizeHtml(html, {
      allowedTags: ['b', 'i', 'strong', 'em', 'a', 'p'],
      allowedAttributes: { a: ['href'] },
    }),
    {
      replace: (node) => {
        if (node.type === 'tag' && node.name === 'a') {
          return (
            <Link
              href={node.attribs.href}
              target="_blank"
            >
              {domToReact(node.children as DOMNode[])}
            </Link>
          );
        }

        return node;
      },
    },
  );
